module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "module-name"
  }, [_vm._v("PROFILE PARTICIPANT")]), _vm._v(" "), (_vm.getLoading) ? _c('vue-spinner') : _c('div', {
    staticClass: "portlet-body row"
  }, [_c('div', {
    staticClass: "col-md-3 min100"
  }, [_c('div', {
    staticClass: "item-head"
  }, [_c('div', {
    staticClass: "item-details"
  }, [_c('avatar', {
    attrs: {
      "username": _vm.username,
      "src": _vm.avatar,
      "size": 80,
      "rounded": true,
      "color": "#d09f23",
      "backgroundColor": "#eef1f5"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "item-details min110"
  }, [_c('router-link', {
    staticClass: "item-name primary-link",
    attrs: {
      "to": {
        name: 'Dashboard Participant',
        params: {
          id: _vm.$route.params.id
        }
      },
      "tag": "a"
    }
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_vm._v("Phone: " + _vm._s(_vm.getParticipant.phone_number))]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_vm._v("Email: " + _vm._s((_vm.getParticipant.profile.email != null) ? _vm.getParticipant.profile.email : '-'))]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_vm._v("Organization ID: " + _vm._s((_vm.getParticipant.organization_id != null) ? _vm.getParticipant.organization_id : '-'))]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_vm._v("System ID: "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.getParticipant.system_id))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "btn-arrow-link pull-right"
  }, [(_vm.getUser.access > 3) ? _c('a', {
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showRemoveModal.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "icon-trash black"
  }), _vm._v(" REMOVE")]) : _vm._e(), _vm._v(" |\n        "), _c('router-link', {
    staticClass: "text-warning",
    attrs: {
      "to": {
        name: 'Participant Edit',
        params: {
          id: (_vm.$route.params.id != null) ? _vm.$route.params.id : ''
        }
      },
      "tag": "a"
    }
  }, [_vm._v("VIEW|EDIT\n          "), _c('i', {
    staticClass: "icon-arrow-right black"
  })])], 1)])]), _vm._v(" "), _c('remove-participant-modal', {
    attrs: {
      "participant-id": _vm.$route.params.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-067404f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ProfileParticipant.vue
// module id = 1543
// module chunks = 1